module.exports = __webpack_public_path__ + "5b46477129bdbb1044b82a956cef8f52.svg";